<template>
  <div class="flex h-13">
    <div
      class="flex items-center bg-pure-white border-b border-l border-r border-slate-400 sticky left-0 z-10"
      :class="{ 'rounded-bl': isLast }"
    >
      <div class="px-4 flex flex-shrink-0 gap-2 bg-pure-white w-20">
        <BlTextBody2 :text="session.id" class="truncate text-slate-1000" />
      </div>
      <div
        class="px-4 flex flex-shrink-0 gap-2 bg-pure-white w-50"
        :title="session.name"
      >
        <BlTextBody2
          :text="session.name || 'Unnamed session'"
          class="truncate text-slate-1000"
        />
      </div>
    </div>
    <div
      class="px-4 flex-shrink-0 bg-pure-white w-40 flex items-center border-b border-slate-400"
    >
      <BlChip :chip="session.status" />
    </div>
    <div
      class="px-4 flex-shrink-0 bg-pure-white w-60 flex items-center border-b border-slate-400"
    >
      <BlTextBody2 :text="sessionAppointment.timeslot" />
    </div>
    <div
      class="pl-4 flex-shrink-0 bg-pure-white w-64 flex items-center border-b border-slate-400"
    >
      <BlTextBody2 :text="recordedAt" />
    </div>
    <div
      class="px-4 flex-shrink-0 bg-pure-white w-40 flex items-center border-b border-slate-400"
    >
      <BlTextBody2 v-if="!session.current_recording_time[0]" :text="'-'" />
      <BlTextBody2 v-else :text="session.current_recording_time[1]" />
    </div>
    <div
      class="px-4 flex-shrink-0 bg-pure-white w-40 flex items-center border-b border-slate-400"
    >
      <BlTextBody2
        v-if="!session.user"
        title="Deleted user"
        text="Deleted user"
        class="italice truncate"
      />
      <div
        v-else
        class="h-8 px-2.5 rounded bg-success-100 flex items-center truncate"
        :title="session.user.name || session.user.email"
      >
        <BlTextBody2
          :text="session.user.name || session.user.email"
          class="text-success truncate"
        />
      </div>
    </div>
    <div
      class="px-4 flex-shrink-0 bg-pure-white w-40 flex items-center border-b border-slate-400"
    >
      <BlTextBody2 :text="session.number_of_measurements" />
    </div>
    <div class="flex sticky right-0 bg-pure-white flex-grow">
      <div
        class="px-4 flex-shrink-0 bg-pure-white w-40 flex-grow flex items-center justify-end gap-2 border-b border-r border-slate-400"
        :class="{ 'rounded-br': isLast }"
      >
        <router-link :to="`/session/${session.slug}`">
          <BlInputButton type="outlined" dense label="View session" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

import BlTextBody2 from "../../BlTextBody2.vue";
import BlChip from "../../BlChip.vue";
import BlInputButton from "../../BlInputButton.vue";

export default {
  name: "SessionPastItem",
  components: {
    BlTextBody2,
    BlChip,
    BlInputButton
  },
  props: {
    session: { type: Object, required: true },
    idx: { type: Number, required: true },
    isLast: { required: false }
    // @after-commit
  },
  computed: {
    ...mapGetters([""]),
    sessionAppointment() {
      if (!this.session.appointment) {
        return {
          id: null,
          date: null,
          timeslot: "Unscheduled",
          user: null,
          supervisors: []
        };
      }

      const appointment = this.session.appointment;
      const date = moment(appointment.date).format("DD/MM/YY");
      const time = appointment.start_time_string
        ? `(${appointment.start_time_string} - ${appointment.end_time_string})`
        : "";
      const timeslot = `${date} ${time}`;

      return { ...appointment, timeslot };
    },
    recordedAt() {
      if (!this.session) return "-";
      if (!this.session.start_time) return "-";

      const start = moment(this.session.start_time)
        .format("DD/MM/YY|HH:mm")
        .split("|");
      const end = moment(this.session.end_time)
        .format("DD/MM/YY|HH:mm")
        .split("|");

      if (start[0] === end[0]) {
        if (start[1] === end[1]) {
          return `${start[0]} ${start[1]}`;
        }
        return `${start[0]} ${start[1]} - ${end[1]}`;
      } else {
        return `${start[0]} ${start[1]} - ${end[0]} ${end[1]}`;
      }
    }
  },
  methods: {
    ...mapActions(["showToast"])
  }
};
</script>



// WEBPACK FOOTER //
// src/components/clients/session/PastItem.vue